<script setup>
import { computed, useSlots } from 'vue';

const slots = useSlots();

const hasStartAdornment = computed(() => !!slots['start-adornment']);

const hasEndAdornment = computed(() => !!slots['end-adornment']);

const wrapperClasses = computed(() => [
  'input-wrapper',
  {
    'input-wrapper--offset-start': hasStartAdornment.value,
    'input-wrapper--offset-end': hasEndAdornment.value,
  },
]);
</script>

<template>
  <div :class="wrapperClasses">
    <div v-if="hasStartAdornment" class="input-adornment input-adornment--start">
      <slot name="start-adornment" />
    </div>

    <slot />

    <div v-if="hasEndAdornment" class="input-adornment input-adornment--end">
      <slot name="end-adornment" />
    </div>
  </div>
</template>
